export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Necesito conocimientos previos de Feng Shui?',
    answer:
      'No. Armonía Interior está pensada para comenzar desde cero y avanzar paso a paso desde los fundamentos hasta su aplicación práctica.',
  },
  {
    question: '¿Sirve si vivo en un departamento pequeño?',
    answer:
      'Sí. Los principios pueden adaptarse a departamentos, monoambientes y casas de cualquier tamaño. Lo importante no es la superficie, sino cómo está distribuido y utilizado el espacio.',
  },
  {
    question: '¿Cómo y cuándo recibo el material?',
    answer:
      'El acceso es inmediato. Al completar la compra recibís por correo electrónico el enlace para descargar la guía y los 5 bonus en formato PDF.',
  },
  {
    question: '¿Puedo aplicarlo si alquilo mi vivienda?',
    answer:
      'Sí. La mayoría de los cambios propuestos son reversibles: ubicación de muebles, textiles, iluminación, plantas, espejos, colores en objetos y orden. No necesitás realizar obras.',
  },
  {
    question: '¿Necesito comprar objetos especiales?',
    answer:
      'No. La guía trabaja principalmente con lo que ya tenés en casa, e incluye un bonus con 50 cambios concretos que podés aplicar sin gastar dinero.',
  },
  {
    question: '¿Los 5 bonus están incluidos en el precio?',
    answer:
      'Sí. Durante la oferta de lanzamiento los 5 recursos adicionales, con un valor real de USD 60, se entregan junto con la guía completa sin costo extra.',
  },
  {
    question: '¿En qué dispositivos puedo leerlo?',
    answer:
      'En cualquier dispositivo que abra archivos PDF: celular, tablet, computadora o e-reader. También podés imprimir las plantillas y checklists.',
  },
  {
    question: '¿En qué moneda se realiza el pago?',
    answer:
      'Si comprás desde Argentina el precio se muestra y se cobra en pesos argentinos. Desde el resto de los países el pago se realiza en dólares.',
  },
]
